<template>
  <div
    v-if="images?.length"
    :class="$style.root"
    :data-on-edition-page="onEditionPage ? '' : null "
  >
    <core-media-carousel-component
      :images="images"
      :class="$style.carousel"
      @setActiveIndex="setActiveIndex"
    >
      <template #caption>
        <div>
          <layout-animated-underline-component
            :to="images[activeIndex]?.entryPagePath"
            :class="$style.link"
            :inverted="true"
            :style="getUnderlineColor(images[activeIndex]?.colors)"
          >

            <template #default>
              {{ images[activeIndex]?.entryTitle }}
            </template>
          </layout-animated-underline-component>
          <div
            v-if="images[activeIndex]?.caption"
          >
            <core-text-component
              :string="images[activeIndex]?.caption"
              :key="images[activeIndex]?.caption"
            />
          </div>
        </div>
      </template>
    </core-media-carousel-component>
  </div>
</template>

<script lang="ts" setup>
import { flattenDeep } from 'lodash-es'

const props = defineProps({
  data: Object,
  onEditionPage: {
    type: Boolean,
    default: false
  }
})

// 1
const imagesFromEducationPages = computed(() => {
  const items = props?.data?.educationPageEntries?.map((entry: any) => {
    const imageBlocks = entry?.blocks?.filter(i => i?.__component === 'blocks.images')?.map((block) => {

      const entryPagePath = props?.onEditionPage ? getEducationSlugPath(entry?.slug, entry?.biennialEntry?.slug) : getEducationSlugPath(entry?.slug, null)

      const images = block?.files?.map((i) => {
        return {
          ...i,
          entryTitle: `${entry?.biennialEntry?.title}: ${entry.title}`,
          colors: entry?.biennialEntry?.colors,
          entryCssColorString: entry?.biennialEntry?.colors ? getCssColors(entry?.biennialEntry?.colors) : null,
          entryPagePath: entryPagePath,
          caption: baseStrapiGetFirstParagraphFromBlocks(entry?.blocks, 40),
          educationPageEntryId: entry?.id,
        }
      })

      return images

    })?.filter(Boolean)

    return useSample(flattenDeep(imageBlocks)?.filter(Boolean))
  })

  return flattenDeep(items)?.filter(Boolean)
})

const getUnderlineColor = (colors: any) => {
  if (props?.onEditionPage) {
    return {
      '--color--text-decoration': 'var(--color--primary)',
    }
  }
  return getCssBackgroundColorTextDecoration(colors)
}

const defaultImages = props?.data?.images
const images = imagesFromEducationPages?.value?.length > 0 ? imagesFromEducationPages?.value : defaultImages

// 2
const activeIndex = ref(0)
const setActiveIndex = (index: number) => {
  activeIndex.value = index
}
</script>

<style module lang="scss">
.root {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.carousel {
  width: 100%;
}

.root:not([data-on-edition-page]) .link {
  color: var(--color--primary--default);
}

.link {
}
</style>
